(function (FragranceFinder) {
  'use strict';

  function initQuizzes() {
    if (!FragranceFinder.QuizController) return;
    const quizzes = document.querySelectorAll('[data-ff-quiz]');
    Array.prototype.forEach.call(quizzes, function (element) {
      if (!element.__ffInit) {
        element.__ffInit = true;
        new FragranceFinder.QuizController(element);
      }
    });
  }

  function initResults() {
    if (!FragranceFinder.ResultsController) return;
    const results = document.querySelectorAll('[data-ff-results]');
    Array.prototype.forEach.call(results, function (element) {
      if (!element.__ffInit) {
        element.__ffInit = true;
        new FragranceFinder.ResultsController(element);
      }
    });
  }

  function init() {
    initQuizzes();
    initResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  FragranceFinder.init = init;
})(window.FragranceFinder = window.FragranceFinder || {});
